// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
const INDEX_SALARY_PATTERN_SUCCESS = "INDEX_SALARY_PATTERN_SUCCESS";
const SHOW_SALARY_FACTOR_SUCCESS = "SHOW_SALARY_FACTOR_SUCCESS";
const STORE_RULE_PACK_SUCCESS = "STORE_RULE_PACK_SUCCESS";
const UPDATE_RULE_PACK_SUCCESS = "UPDATE_RULE_PACK_SUCCESS";
const DESTROY_RULE_PACK_SUCCESS = "DESTROY_RULE_PACK_SUCCESS";
// ******************************************************************** rulePackRules **********************************************************************
const INDEX_FACTOR_SALARY_ITEMS_SUCCESS = "INDEX_FACTOR_SALARY_ITEMS_SUCCESS";
const SHOW_FACTOR_SALARY_ITEM_SUCCESS = "SHOW_FACTOR_SALARY_ITEM_SUCCESS";
const STORE_FACTOR_SALARY_ITEM_SUCCESS = "STORE_FACTOR_SALARY_ITEM_SUCCESS";
const UPDATE_FACTOR_SALARY_ITEM_SUCCESS = "UPDATE_FACTOR_SALARY_ITEM_SUCCESS";
const DESTROY_FACTOR_SALARY_ITEM_SUCCESS = "DESTROY_FACTOR_SALARY_ITEM_SUCCESS";

const INDEX_FACTOR_SALARY_ITEMS_FORM_SUCCESS = "INDEX_FACTOR_SALARY_ITEMS_FORM_SUCCESS";
const INDEX_ASSIGNMENT_SALARY_SUCCESS = "INDEX_ASSIGNMENT_SALARY_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  console.log("payload", payload);
  return {
    type: INDEX_SALARY_PATTERN_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  console.log("wefwef", payload);

  return {
    type: SHOW_SALARY_FACTOR_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccessCustom(payload) {
  return {
    type: SHOW_SALARY_FACTOR_SUCCESS,
    payload: payload.data.geoFence,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_RULE_PACK_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** rulePackRules **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexRulePackRulesSuccess(payload) {
  return {
    type: INDEX_FACTOR_SALARY_ITEMS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showFactorSalaryItemsSuccess(payload) {
  return {
    type: SHOW_FACTOR_SALARY_ITEM_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeRulePackRuleSuccess(payload) {
  return {
    type: STORE_FACTOR_SALARY_ITEM_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateRulePackRuleSuccess(payload) {
  return {
    type: UPDATE_FACTOR_SALARY_ITEM_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroyRulePackRuleSuccess(payload) {
  return {
    type: DESTROY_FACTOR_SALARY_ITEM_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showRule(payload) {
  return {
    type: INDEX_FACTOR_SALARY_ITEMS_FORM_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccessAssignment(payload) {
  return {
    type: INDEX_ASSIGNMENT_SALARY_SUCCESS,
    payload: payload,
  };
}
// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/SalaryCalculateItem/GetSalaryCalculateItems", { params })
      .then((r) => {
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexSalary(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ta/shifts", { params })
      .then((res) => {
        dispatch(_indexSuccessAssignment(res));
        console.log("ecsevwsv", res);
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.shift",
          "ثبت درخواست شکست خورد",
          app.translate("routes.home.attendance.shift.Indexing Shifts Failed")
        );
        callback(err);
      });
  };
}
/**
 *
 * @param {Number} showFactor
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(showFactor, params = {}, callback = () => {}) {
  console.log("345345345334534534533453453453", showFactor);

  return (dispatch, gs, api) => {
    api
      .get(`/SalaryCalculateItem/GetSalaryCalculateItem/${showFactor}`)
      .then((r) => {
        dispatch(_showSuccess(r));
        console.log("345345345334534534533453453453", r);

        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} showFactor
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function shows(showFactor, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/Ta/GeoFences/${showFactor}`, { params })
      .then((r) => {
        dispatch(_showSuccessCustom(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} rule
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showForm(rule, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/ta/rules/${rule}`, { params })
      .then((res) => {
        dispatch(_showRule(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.rules",
          "Rule",
          app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.rule-pack.Adding New RulePack"
      )
    );

    api
      .post("/SalaryCalculateItem/EditSalaryCalculateItem", { data })
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.rule-pack.New RulePack Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "RulePack",
            app.translate(
              "routes.home.requests.pattern.rule-pack.Adding New RulePack Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} showFactor
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(showFactor, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.pattern.rule-pack.Updating RulePack")
    );

    api
      .put(`/SalaryCalculateItem/EditSalaryCalculateItem`, { data })
      .then((r) => {
        dispatch(_updateSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.rule-pack.RulePack Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "RulePack",
            app.translate(
              "routes.home.requests.pattern.rule-pack.Updating RulePack Failed"
            )
          )
        );
      });
  };
}



/**
 *
 * @return {Function}
 */
export function emptyShowFactors() {
  return _indexSuccess({ data: { showFactors: [] }, meta: {} });
}

/**
 *
 * @return {Function}
 */
export function emptyRule() {
  return _showRule({ data: { rule: {} } });
}

// ******************************************************************** rulePackRules **********************************************************************



/**
 *
 * @param {Number} rulePackRule
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showFactorSalaryItems(
  rulePackRule,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`Salary/GetSalaryPatternDetail?id=${rulePackRule}`, { params })
      .then((res) => {
        dispatch(_showFactorSalaryItemsSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeRulePackRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.rule-pack.Adding New RulePackRule"
      )
    );

    api
      .put("/Salary/EditSalaryPatternDetailValues", { data })
      .then((r) => {
        dispatch(_storeRulePackRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.rule-pack.New RulePackRule Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "RulePack",
            app.translate(
              "routes.home.requests.pattern.rule-pack.Adding New RulePack Failed"
            )
          )
        );
      });
  };
}





/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyShowFactor() {
  return _showSuccess({ data: { showFactor: {} } });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRulePackRules() {
  return _indexRulePackRulesSuccess({ data: { salaryFactorItems: [] }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRulePackRule() {
  return _showFactorSalaryItemsSuccess({ data: { ShowFactorItem: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    showFactors: [],
    showFactor: {},
    salaryFactorItems: [],
    ShowFactorItem: {},
    rule: {},
    metaShowFactors: {},
    metaSalaryFactorItems: {},
    shift: {},
  },
  action
) {
  let showFactors;
  let showFactor;
  let _index;
  let _meta;

  switch (action.type) {
    case INDEX_SALARY_PATTERN_SUCCESS:
      return Object.assign({}, state, {
        showFactors: action.payload.data.data,
        metaShowFactors: action.payload.meta,
      });
    case SHOW_SALARY_FACTOR_SUCCESS:
      return Object.assign({}, state, {
        showFactor: action.payload,
      });
    case STORE_RULE_PACK_SUCCESS:
      showFactors = app._.cloneDeep(state.showFactors);
      showFactors.push(action.payload);
      return Object.assign({}, state, {
        showFactor: action.payload,
        showFactors,
      });
    case UPDATE_RULE_PACK_SUCCESS:
      // showFactors = app._.cloneDeep(state.showFactors);
      // showFactor = app._.cloneDeep(state.showFactor);
      // _index = showFactors.findIndex(
      //   (_showFactor) => _showFactor.id === action.payload.id
      // );
      // showFactors[_index] = action.payload;
      // showFactor.name = action.payload.name;
      // showFactor.description = action.payload.description;
      return Object.assign({}, state, {
        showFactor,
      });
    case DESTROY_RULE_PACK_SUCCESS:
      showFactors = app._.cloneDeep(state.showFactors);
      _index = showFactors.findIndex(
        (_showFactor) => _showFactor.id === action.payload
      );
      showFactors.splice(_index, 1);
      return Object.assign({}, state, {
        showFactors,
        showFactor: null,
        rulePackRule: null,
      });
    case INDEX_FACTOR_SALARY_ITEMS_SUCCESS:
      return Object.assign({}, state, {
        salaryFactorItems: action.payload.data.rulePackRules,
        metaSalaryFactorItems: action.payload.meta,
      });
    case SHOW_FACTOR_SALARY_ITEM_SUCCESS:
      return Object.assign({}, state, {
        rulePackRule: action.payload,
      });
    case STORE_FACTOR_SALARY_ITEM_SUCCESS:
      showFactor = app._.cloneDeep(state.showFactor);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(showFactor.rules)) {
        _rules.push(...showFactor.rules);
      }
      showFactor.rules = _rules;
      return Object.assign({}, state, {
        rulePackRule: action.payload,
        showFactor,
      });
    case UPDATE_FACTOR_SALARY_ITEM_SUCCESS:
      showFactor = app._.cloneDeep(state.showFactor);
      if (showFactor?.rules) {
        _index = showFactor.rules.findIndex(
          (_rulePackRule) => _rulePackRule.id === action.payload.id
        );
        showFactor.rules[_index] = action.payload;
      }

      return Object.assign({}, state, {
        rulePackRule: action.payload,
        showFactor,
      });
    case DESTROY_FACTOR_SALARY_ITEM_SUCCESS:
      showFactor = app._.cloneDeep(state.showFactor);
      _index = showFactor.rules.findIndex(
        (_rulePackRule) => _rulePackRule.id === action.payload
      );
      showFactor.rules.splice(_index, 1);
      return Object.assign({}, state, {
        showFactor,
      });
    case INDEX_FACTOR_SALARY_ITEMS_FORM_SUCCESS:
      return Object.assign({}, state, {
        rule: action.payload.rule,
      });
    case INDEX_ASSIGNMENT_SALARY_SUCCESS:
      console.log("action.payloadsvsd", action.payload);
      _meta = action.payload.meta;
      return Object.assign({}, state, {
        shifts: action.payload,
        pagination: _meta
          ? app.pagination(_meta.currentPage + 1, _meta.total, _meta.limit)
          : {},
      });
    default:
      return state;
  }
}
